export const REGISTRATION_SOURCE = 'registration_overlay';
export const REGISTRATION_PLATFORM = 'mobile';
